import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { HatchInput, HatchOutput, WebAppRoutes } from "types/web-app";

export const hatch = async (accessToken: string, input: HatchInput) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.HATCH,
      accessToken,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(input),
      },
    );

    const data = (await response.json()) as ServiceResponse<HatchOutput>;

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

